<template>
  <div>
    <div :id="values.id" />
  </div>
</template>

<script>
export default {
  props: {
    adstype: {
      type: String,
      default: ''
    },
    position: {
      type: Number,
      default: undefined
    },
    values: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    slot: ''
  }),
  mounted() {
    setTimeout(() => {
      // Evento que escucha cuando ha acabado de renderizar el anuncio en el Iframe,
      // para chequear si ese anuncio esta vacío
      if (!window.googletag.pubads) {
        this.$emit('emptySliderAds', { ad: this.values })
      }
      // Creación del slot de anuncio, aquí le indicamos el id del div donde tiene que incluirlo
      var self = this
      ;(() => {
        function createSlot(type, values) {
          window.googletag.cmd = window.googletag.cmd || []
          window.googletag.cmd.push(function() {
            self.slot = window.googletag.defineSlot(
              `/5555,21692105105/WEGOW.ES/${type}`,
              ['fluid'],
              values.id
            )
            window.googletag
              .pubads()
              .addEventListener('slotRenderEnded', event => {
                console.log(event)
                if (self.slot === event.slot) {
                  if (event.isEmpty) {
                    if (!event.slot.dynamic) {
                      console.log('empty 2 id: ', event.slot.id)
                      console.log('empty 2: ', event.slot)
                      self.$emit('emptySliderAds', { ad: self.values })
                    } else {
                      console.log('empty dynamic id: ', event.slot.id)
                      console.log('empty dynamic: ', event.slot)
                      var dynamic = document.getElementById('wegow-ads-dynamic')
                      if (dynamic.parentNode)
                        // dynamic.parentNode.removeChild(dynamic)
                      self.$root.$emit('emptyDynamicAd')
                    }
                  }
                }
              })
            if (self.slot && typeof self.slot.addService === 'function') {
              self.slot.addService(window.googletag.pubads())
              self.slot.position = values.wegow_position
              if (values) {
                self.slot.id = values.id
                for (const key in values) {
                  self.slot.setTargeting(key, values[key])
                  self.slot[key] = values[key]
                }
              }
              if (self.adstype === 'wegow-web-dynamic-ad') {
                self.slot.dynamic = true
              }
              window.googletag.display(values.id)
              window.googletag.pubads().refresh([self.slot])
            }
          })
        }

        createSlot(this.adstype, this.values)
      })()
    }, 1500)
  }
}
</script>
